import React from 'react';
import { invokeApiWithCancel, isCancelError } from '@/helpers/invokeApiWithCancel';

export const useLoad = (data) => {
	const { last = true, api, transformData = (obj) => obj } = data;
	// элементы
	const [state, setState] = React.useState(data.initState ?? '');

	// индикация загрузки
	const [loading, setLoading] = React.useState(last);

	// ошибки
	const [error, setError] = React.useState('');

	// метод загрузки
	const getState = () => {
		if(!data?.cancelResetOnReceipt) {
			setState(data.initState ?? '');
		}
		setLoading(true);
		invokeApiWithCancel(api, data?.params, data.getCancelTokenSource)
			.then((res) => {
				if (isCancelError(res)) {
					setLoading(false);
					return;
				}
				setLoading(false);
				if (res.status === 200) {
					if (data.key !== undefined) setState(transformData(res.data[data.key]));
					else setState(transformData(res.data));
				}
			})
			.catch((err) => {
				if (isCancelError(err)) return;
				setError(err);
			});
	};

	// первая загрузка
	// eslint-disable-next-line react-hooks/exhaustive-deps
	React.useEffect(() => {
		last && api && getState();
	}, []);

	// сброс
	const reset = () => {
		setState(data.initState ?? '');
	};

	return { state, getState, setState, loading, error, reset };
};

export default useLoad;
